export const GET_DATA_PLATFORM_ADMINISTRATION         = 'GET_DATA_PLATFORM_ADMINISTRATION'
export const CREATE_UPDATE_PLATFORM_ADMINISTRATION    = 'CREATE_UPDATE_PLATFORM_ADMINISTRATION'
export const LOADING_PLATFORM_ADMINISTRATION          = 'LOADING_PLATFORM_ADMINISTRATION'